import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';

/**
 * Route-level guard that protects guest-only routes (login, register, etc.).
 * Redirects authenticated users to /dashboard.
 * Renders child routes via <Outlet /> when NOT authenticated.
 *
 * Usage in routes:
 * ```tsx
 * <Route element={<GuestGuard />}>
 *   <Route path="/login" element={<LoginPage />} />
 * </Route>
 * ```
 */
export function GuestGuard() {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
